import { RDate, makeImmutable } from "../../core";
import { Consents } from "../Consents";
import { ContactDetails, } from "../ContactDetails";
import { Delivery } from "../Delivery";
import { ApartmentInfo, DeliveryAddress, } from "../DeliveryAddress";
import { FulfillmentInstructions } from "../FulfillmentInstructions";
import { FulfillmentTime, } from "../FulfillmentTime";
import { InvoiceRequest } from "../Invoice";
import { OrderReceiver } from "../OrderReceiver";
import { PromotionScheme } from "../PromotionScheme";
import { PurchaseOrder } from "../PurchaseOrder/PurchaseOrder";
import { PurchaseOrderFulfillmentTime } from "../PurchaseOrderFulfillmentTime";
import { PurchaseOrderPayload } from "../PurchaseOrderPayload";
import { StreetAddress } from "../StreetAddress";
import { PurchaseOrderScope } from "../ParameterScope";
import { ProductInstanceCreator } from "../ProductInstanceCreator";
export class PurchaseOrderFactory {
    constructor(params) {
        this.country = params.country;
        this.salesChannel = params.salesChannel;
        this.validatePhoneService = params.validatePhoneService;
        this.geocodingService = params.geocodingService;
        this.dineInLocationNumber = params.dineInLocationNumber;
        this.isQrWaiterOrder = params.isQrWaiterOrder;
        makeImmutable(this);
    }
    createPayload(params) {
        if (params.cartStorageData === null) {
            return PurchaseOrderPayload.empty(params.menu);
        }
        const uninitializedPayload = PurchaseOrderPayload.fromStorageData({
            menu: params.menu,
            storageData: params.cartStorageData.purchaseOrderPayload,
        });
        return uninitializedPayload.mapProductInstances((productInstance) => {
            const productInstanceCreator = ProductInstanceCreator.create({
                productCategories: params.menu.productCategories,
                productTypes: params.menu.productTypes,
                productInstance,
            });
            productInstanceCreator.initWithScope(params.purchaseOrderScope);
            return productInstanceCreator.instance;
        });
    }
    create(params) {
        const now = RDate.now(params.restaurant.timezone);
        if (params.cartStorageData !== null &&
            params.cartStorageData.restaurantId !== params.restaurant.id.value) {
            // FIXME e2e tests
            // throw new Error("Cart restaurant id deserialization mismatch");
            console.warn("Cart restaurant id deserialization mismatch");
        }
        const orderReceiver = new OrderReceiver({
            invoiceRequest: params.invoiceRequestStorageData === null
                ? null
                : InvoiceRequest.fromStorageData(params.invoiceRequestStorageData),
            contactDetails: params.contactDetailsStorageData === null
                ? ContactDetails.empty({
                    isQrWaiterOrder: this.isQrWaiterOrder,
                    validatePhoneService: this.validatePhoneService,
                    contactDetailsLock: params.contactDetailsLock,
                })
                : ContactDetails.fromStorageData({
                    validatePhoneService: this.validatePhoneService,
                    storageData: params.contactDetailsStorageData,
                    contactDetailsLock: params.contactDetailsLock,
                }),
            consents: Consents.fromStorageData(params.consentsStorageData),
        });
        const deliveryAddress = new DeliveryAddress({
            restaurantId: params.restaurant.id,
            geocodingService: this.geocodingService,
            streetAddress: StreetAddress.fromStorageData({
                country: this.country,
                storageData: params.streetAddressStorageData,
            }),
            apartmentInfo: ApartmentInfo.fromStorageData({
                country: this.country,
                storageData: params.apartmentInfoStorageData,
            }),
        });
        const fulfillmentTime = params.fulfillmentTimeStorageData === null
            ? null
            : FulfillmentTime.fromStorageData({
                now,
                storageData: params.fulfillmentTimeStorageData,
            });
        const fulfillmentInstructions = FulfillmentInstructions.create({
            restaurant: params.restaurant,
            dineInLocationNumber: this.dineInLocationNumber,
            deliveryAddress,
            fulfillmentTime,
        });
        const delivery = new Delivery({
            restaurantId: params.restaurant.id,
            geocodingService: this.geocodingService,
            fulfillmentInstructions,
            defaultMinOrderValue: params.restaurant.minOrderValue.default,
        });
        const purchaseOrderScope = new PurchaseOrderScope({
            restaurant: params.restaurant,
            salesChannel: this.salesChannel,
            fulfillmentInstructions,
            now,
        });
        const payload = this.createPayload({
            menu: params.restaurant.menu,
            cartStorageData: params.cartStorageData,
            purchaseOrderScope,
        });
        const purchaseOrderFulfillmentTime = PurchaseOrderFulfillmentTime.create({
            restaurant: params.restaurant,
            payload,
            fulfillmentInstructions,
            now,
        });
        const promotionScheme = params.cartStorageData === null
            ? PromotionScheme.empty({
                inCartPromotionTypes: params.inCartPromotionTypes,
                purchaseOrderPayload: payload,
            })
            : PromotionScheme.fromStorageData({
                inCartPromotionTypes: params.inCartPromotionTypes,
                purchaseOrderPayload: payload,
                storageData: params.cartStorageData.promotionScheme,
            });
        promotionScheme.setScope(purchaseOrderScope);
        const purchaseOrder = new PurchaseOrder({
            restaurant: params.restaurant,
            origin: this.salesChannel,
            payload,
            orderReceiver,
            delivery,
            fulfillmentInstructions,
            purchaseOrderFulfillmentTime,
            promotionScheme,
        });
        return { purchaseOrder, purchaseOrderScope };
    }
}
